var React = require('react');

function HandInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#004c97","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M25.2 17v10.2M25.2 17c-.1-2.1-1.8-3.8-4-3.7-2.1 0-3.9 1.8-3.9 3.9M9.4 39.3V30c-.1-2.1-1.9-3.8-4-3.7-2.1 0-3.9 1.8-3.9 3.9v10.1c0 2.9.8 5.7 2.3 8.2l8.2 14c.7 1.2 1.1 2.5 1 3.9v11M25.2 21.7c.1-2.1 1.8-3.8 3.9-3.9 2.1-.1 3.9 1.6 4 3.7v5.7","key":0}),React.createElement("path",{"d":"M9.4 30.5V5.4c0-2.1 1.8-3.9 3.9-3.9 2.1-.1 3.9 1.6 4 3.7v22M34.8 77.6V66.3c0-1.4.4-2.8 1.1-4l2.8-4.5c.9-1.5 1.6-3 2-4.7.2-.8.3-1.6.3-2.4V26.1c-.1-2.1-1.8-3.8-4-3.7-2.1 0-3.9 1.8-3.9 3.9","key":1})]));
}

HandInline.defaultProps = {"width":"23.6","height":"44","viewBox":"0 0 42.5 79.1"};

module.exports = HandInline;

HandInline.default = HandInline;
